import { Link } from 'react-router-dom';

export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Sellers',
      description: 'Every seller in our AllChinaBuy Spreadsheet goes through a rigorous verification process. We check transaction history, product quality, and buyer feedback before listing any seller.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Updated Links',
      description: 'Our AllChinaBuy Spreadsheet is refreshed daily. Dead links are removed immediately, and new product discoveries are added within hours of verification.',
    },
    {
      icon: 'ri-file-search-line',
      title: 'QC Guides',
      description: 'Comprehensive quality control guides help you inspect products before shipping. Learn what to look for in QC photos and how to spot potential issues.',
    },
    {
      icon: 'ri-ship-line',
      title: 'Shipping Tutorials',
      description: 'Step-by-step shipping tutorials make international ordering simple. From declaring values to choosing shipping lines, we cover everything beginners need to know.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Why Thousands of Buyers Use Our<br className="hidden md:block" />
            AllChinaBuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg">
            Our team of experienced buyers maintains the most comprehensive and reliable spreadsheet directory available online.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/articles/best-allchinabuy-spreadsheet-2026"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
          >
            Learn more about how we verify and update our spreadsheet
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}